export default getText => key =>
  ({
    title1: getText('Another tab is open with MIA.', 'OtherTabOpen'),
    title2: getText('Only one instance is allowed.', 'OtherTabOpen'),
    title3: getText('Please choose between closing this tab or the other one.', 'OtherTabOpen'),
    btnLabel: getText('Reload', 'OtherTabOpen'),
  }[key])
